import IFinancedSubjectAbstract from "./IFinancedSubjectAbstract";
import FinancedSubjectType from "./FinancedSubjectTypeEnum";

export default class FinancedSubjectAbstract implements IFinancedSubjectAbstract {
    constructor(public type: FinancedSubjectType) {}
}
